import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const userActivityLogsAdapter = createEntityAdapter({})

const initialState = userActivityLogsAdapter.getInitialState()

export const userActivityLogsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserActivityLogs: builder.query({
            query: (userId) => ({
                url: `/userActivityLogs/getUserActivityLogs/${userId}`,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserActivityLogs = responseData.map(userActivityLog => {
                    userActivityLog.id = userActivityLog._id
                    return userActivityLog
                })
                return userActivityLogsAdapter.setAll(initialState, loadedUserActivityLogs)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserActivityLog', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserActivityLog', id}))
                    ]
                } else {
                    return [ { type: 'UserActivityLog', id: 'LIST'}]
                }
            },
        }),
    }),
})

export const {
    useGetUserActivityLogsQuery,
} = userActivityLogsApiSlice

// returns the query result object
export const selectUserActivityLogResult = userActivityLogsApiSlice.endpoints.getUserActivityLogs.select()

// create memoized selector
const selectUserActivityLogsData = createSelector(
    selectUserActivityLogResult,
    userActivityLogResult => userActivityLogResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserActivityLogs,
    selectById: selectUserActivityLogById,
    selectIds: selectUserActivityLogIds,
} = userActivityLogsAdapter.getSelectors(state => selectUserActivityLogsData(state) ?? initialState)